<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="hoursDialogVisible"
      :title="$t('base.openingHours')"
      top="5vh"
      width="800px"
      @close="resetBusinessHours"
    >
      <div v-if="newFormInline.siteBusinessTimeData.length < 7" style="margin-bottom: 15px">
        <el-button
          v-if="isModify"
          icon="el-icon-plus" size="small" type="primary"
          @click="clickAddData"
        >
          <!-- 添加营业时间 -->
          {{ $t('collectionCenter.addBusinessHours') }}
        </el-button>
      </div>
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="newFormInline"
        class="demo-ruleForm"
        label-position="top"
        size="mini"
      >
        <el-table
          :data="newFormInline.siteBusinessTimeData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="450"
          max-height="600"
          style="width: 100%"
        >
          <el-table-column min-width="150" prop="sysDictIds">
            <template v-slot:header>
              <div>
                <span v-if="isModify" style="color: #f00">*</span>
                {{ $t('GlobalSetObj.Date') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <el-form-item
                  :prop="'siteBusinessTimeData.' + scope.$index + '.sysDictIds'"
                  :rules="[
                    {
                      required: true,
                      message: $t('GlobalSetObj.pleaseInput'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                >
                  <el-select
                    v-model="scope.row.sysDictIds"
                    clearable
                    filterable
                    multiple
                    placeholder=""
                    :disabled="!isModify"
                  >
                    <el-option
                      v-for="item in weekList"
                      :key="item.dictId"
                      :label="item.dictDescribe"
                      :value="item.dictId"
                      :disabled="
                        newFormInline.siteBusinessTimeData.some(
                          (item1, index) =>
                            item1.sysDictIds.includes(item.dictId) && index !== scope.$index
                        )
                      "
                    />
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="200" prop="businessStartTime">
            <template v-slot:header>
              <div>
                <span v-if="isModify" style="color: #f00">*</span>
                {{ $t('collectionCenter.businessStartTime') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <el-form-item
                  :prop="'siteBusinessTimeData.' + scope.$index + '.businessStartTime'"
                >
                  <el-time-picker
                    v-model="scope.row.businessStartTime"
                    :placeholder="$t('collectionCenter.StartTime')"
                    format="HH:mm"
                    style="width: 100%"
                    value-format="HH:mm"
                    :disabled="!isModify"
                    @change="(val) => changeStartTime(val, scope.$index)"
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="200" prop="businessEndTime">
            <template v-slot:header>
              <div>
                <span v-if="isModify" style="color: #f00">*</span>
                {{ $t('collectionCenter.businessEndTime') }}
              </div>
            </template>
            <template #default="scope">
              <div class="flx-center">
                <el-form-item
                  :prop="'siteBusinessTimeData.' + scope.$index + '.businessEndTime'"
                  :rules="[
                    {
                      required: true,
                      message: $t('GlobalSetObj.pleaseInput'),
                      trigger: ['change', 'blur']
                    }
                  ]"
                >
                  <el-time-picker
                    v-model="scope.row.businessEndTime"
                    :placeholder="$t('collectionCenter.StartTime')"
                    format="HH:mm"
                    style="width: 100%"
                    value-format="HH:mm"
                    :disabled="!isModify"
                    @change="(val) => changeEndTime(val, scope.$index)"
                  />
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isModify"
            :label="$t('GlobalSetObj.operate')"
            align="center"
            fixed="right"
            width="100"
          ><!-- 删除 -->
            <template slot-scope="scope">
              <el-popconfirm
                :title="$t('collectionCenter.deleteSure')"
                @confirm="deleteWeekRow(scope.row)"
              ><!-- 确定删除吗？ -->
                <span slot="reference" class="el-icon-delete" style="color: #00A551; font-size: 22px" />
                <!-- 删除 -->
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div v-if="isModify" class="flx-center" style="margin-top: 15px">
        <div>
          <el-button size="small" type="primary" @click="saveBusinessHours">
            {{ $t('uploadFile.submit') }}
          </el-button>
          <el-button plain size="small" @click="resetForm">
            {{ $t('customerManagements.reset') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { siteBusinessTimeGetAllBusinessWeek } from '@/api/lanshou';

export default {
  data() {
    return {
      weekList: [],
      hoursDialogVisible: false,
      newFormInline: {
        siteBusinessTimeData: []
      },
      exportDialog: false,
      deleteFlag: 1,
      isModify: false
    };
  },
  created() {
    this.getSiteWeekList();
  },
  methods: {
    // 查看
    readDialog(val) {
      this.isModify = false;
      this.hoursDialogVisible = true;
      this.newFormInline.siteBusinessTimeData = val;
    },
    // 添加
    showDialog(val) {
      this.isModify = true;
      this.hoursDialogVisible = true;
      this.newFormInline.siteBusinessTimeData = val;
    },
    /**
     * @description: 获取营业时间字典列表
     */
    getSiteWeekList() {
      siteBusinessTimeGetAllBusinessWeek()
        .then((res) => {
          if (res.code === 200) {
            this.weekList = res.data;
            const weekListObj = {};
            this.weekList.forEach((item) => {
              weekListObj[item.dictId] = item.dictDescribe;
            });
            this.weekListObj = weekListObj;
          }
        })
        .catch({});
    },
    /**
     * @description: 重置营业时间
     */
    resetBusinessHours() {
      this.newFormInline.siteBusinessTimeData = [];
      this.hoursDialogVisible = false;
    },
    /**
     * @description: 营业时间选择开始时间
     */
    changeStartTime(val, index) {
      if (
        this.newFormInline.siteBusinessTimeData[index].businessEndTime &&
        this.newFormInline.siteBusinessTimeData[index].businessStartTime
      ) {
        if (val > this.newFormInline.siteBusinessTimeData[index].businessEndTime) {
          this.$message.warning(this.$t('collectionCenter.pleaseChooseAgainTime')); // 开始时间不能大于结束时间
          this.newFormInline.siteBusinessTimeData[index].businessStartTime = '';
        }
      }
    },
    /**
     * @description: 营业时间选择结束时间
     */
    changeEndTime(val, index) {
      if (
        this.newFormInline.siteBusinessTimeData[index].businessStartTime &&
        this.newFormInline.siteBusinessTimeData[index].businessEndTime
      ) {
        if (this.newFormInline.siteBusinessTimeData[index].businessStartTime > val) {
          this.$message.warning(this.$t('collectionCenter.pleaseChooseAgainTime')); // 结束时间不能小于开始时间
          this.newFormInline.siteBusinessTimeData[index].businessEndTime = '';
        }
      }
    },
    resetForm() {
      this.newFormInline.siteBusinessTimeData = [];
    },
    deleteWeekRow(row) {
      const index = this.newFormInline.siteBusinessTimeData.findIndex(item => item.id === row.id);
      if (index !== -1) {
        this.newFormInline.siteBusinessTimeData.splice(index, 1);
      }
    },
    clickAddData() {
      this.newFormInline.siteBusinessTimeData.unshift({
        sysDictIds: [],
        businessStartTime: '',
        businessEndTime: ''
      });
    },
    /**
     * @description: 保存营业时间
     */
    saveBusinessHours() {
      if (!this.newFormInline.siteBusinessTimeData || this.newFormInline.siteBusinessTimeData.length <= 0) {
        this.$message.error(this.$t('operatingPlatform.noData'));
        return;
      }
      let isCheck = true;
      this.newFormInline.siteBusinessTimeData.forEach((item) => {
        if (!item.sysDictIds || !item.businessStartTime || !item.businessEndTime) {
          isCheck = false;
        }
      });
      if (!isCheck) {
        this.$message.warning(this.$t('userManage.pleaseCheck')); // 请填写完整的营业时间
        return;
      }
      this.hoursDialogVisible = false;
      this.$emit('getDate', this.newFormInline.siteBusinessTimeData);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
}

.editOperation {
  color: #00A551;
  cursor: pointer;
}

.delOperation {
  color: #ff1135;
  cursor: pointer;
}

.cancalOperation {
  color: #009743;
  cursor: pointer;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #00A551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
  background-color: #f5f7fa;
  padding: 5px;
}

.uploadArea {
  text-align: center;
  background-color: #f2f3f5;
  padding: 20px 0;
  width: 70%;
  margin: 10px auto;
  cursor: pointer;
}
</style>
